jQuery(document).ready(function () {

    // Open navbarSide when button is clicked
    jQuery('#navbarSideButton').on('click', function () {
        jQuery('#navbarSide').addClass('reveal');
        jQuery('.overlayy').show();
    });

    // Close navbarSide when the outside of menu is clicked
    jQuery('.overlayy').on('click', function () {
        jQuery('#navbarSide').removeClass('reveal');
        jQuery('.overlayy').hide();
    });


    /**
     * Events with Google Analytics through Tealium
     *
     * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits
     * @link https://community.tealiumiq.com/t5/Tags/Google-Universal-Analytics-Event-Tracking/ta-p/14082
     * @since 06/26/2019
     */
    function gaEvent(target, action, label) {
        if (typeof window.utag === "object") {
            var utagSend = window.utag;

            utagSend.link({
                ga_events: [{
                    eventCategory: target,
                    eventAction: action,
                    eventLabel: label,
                }]
            });
        }
    }

    switch (window.location.hostname) {
        case 'www.800loanmart.com':
            gaEvent('track', 'env', 'production');
            break;
        case 'stg.800loanmart.com':
        case 'ec2-18-144-70-218.us-west-1.compute.amazonaws.com':
            gaEvent('track', 'env', 'staging');
            break;
        default:
            gaEvent('track', 'env', 'development');
            break;
    }

    // Track page view via events to set filters on GA for each view type
    gaEvent('track', 'view', LM_CFG.gaPageView);

    // people who click on the phone number to call us
    jQuery(document).on('click', '#mainNavPhoneNumber', function (e) {
        gaEvent('phone call', 'click', 'phone-call-click');
    });

    // people who click on the apply now button on the top right next to the phone number
    jQuery('[href="https://www2.800loanmart.com/application/application"]').on('click', function (e) {
        gaEvent('apply now', 'click', 'apply-now-click');
    });

    // people who click on the Espanol version of the website
    jQuery('.language_selector .spanish').on('click', function (e) {
        gaEvent('espanol', 'click', 'espanol-click');
    });

    // people who click on the English version of the website
    jQuery('.language_selector .english').on('click', function (e) {
        gaEvent('english', 'click', 'english-click');
    });


    /**
     * navbar on scroll
     */
    if (jQuery('body').hasClass('fruits-theme')) {
        var navbar = jQuery(".js-lm-navbar"),
            defaultPosition = {top: 0, left: 0}; //navbar.position();

        if ($(window).scrollTop() > 3) {
            navbar.addClass("on-scroll");
        }

        jQuery(window).scroll(function () {
            var windowPosition = jQuery(window).scrollTop();
            if (windowPosition >= defaultPosition.top & windowPosition < 3) {
                navbar.removeClass("on-scroll");
            } else {
                navbar.addClass("on-scroll");
            }
        });
    }

});
